import { StoreCommonService } from './../../../../services/store/store-common.service';
/// <reference path="../../../../../../node_modules/@angular/core/src/metadata/directives.d.ts"/>
import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {FormBuilder, FormGroup, FormControl, Validator, Validators} from '@angular/forms';
import {StoreModel} from '../../../../models/store-common.model';
import {LoyaltyParamsService} from '../../../../services/loyalty/params.service';
import {KoncentroValidators} from '../../../../modules/UIKit/validators/koncentro-validators';

@Component({
  selector: 'app-kv-store-common-link',
  templateUrl: './store-common-link.component.html',
  providers: []
})
export class StoreCommonLinkComponent implements OnInit {

  @Input() editMode: boolean;

  formLink: FormGroup;
  listAnalyticType: Array<{ label: string, value: string}>;
  listBackOfficeType: Array<{ label: string, value: string}>;
  listFrontEndType: Array<{ label: string, value: string}>;
  listLoyaltyType: Array<{ label: string, value: string}>;
  listPromotionType: Array<{ label: string, value: string}>;
  listCustomerType: Array<{ label: string, value: string}>;
  listCouponingType: Array<{ label: string, value: string}>;

  fields: any;
  invalidSubmit: boolean;

  validationData = null;

  constructor(
    private fb: FormBuilder,
    private paramService: LoyaltyParamsService,
    private srvStore: StoreCommonService) {}

  ngOnInit(): void {
    this.loadAnalyticType();
    this.loadBackOfficeType();
    this.loadFrontEndType();
    this.loadLoyaltyType();
    this.loadPromotionType();
    this.loadCustomerType();
    this.loadCouponingType();
    this.loadValidation();
  }

  loadValidation() {
    this.srvStore.getFields().subscribe(res => {
      this.fields = res
    });
  }

  loadAnalyticType() {
    this.paramService.list(null , null , [{key: 'param_group', value: 'AnalyticType'}]).subscribe(res => {
      this.listAnalyticType = [];
      for (const analyticType of res.data) {
        this.listAnalyticType.push({ label: analyticType.description, value: analyticType.id });
      }
    });
  }

  loadBackOfficeType() {
    this.paramService.list(null , null , [{key: 'param_group', value: 'BackOfficeType'}]).subscribe(res => {
      this.listBackOfficeType = [];
      for (const backOfficeType of res.data) {
        this.listBackOfficeType.push({ label: backOfficeType.description, value: backOfficeType.id });
      }
    });
  }

  loadFrontEndType() {
    this.paramService.list(null , null , [{key: 'param_group', value: 'FrontEndType'}]).subscribe(res => {
      this.listFrontEndType = [];
      for (const frontEndType of res.data) {
        this.listFrontEndType.push({ label: frontEndType.description, value: frontEndType.id });
      }
    });
  }

  loadLoyaltyType() {
    this.paramService.list(null , null , [{key: 'param_group', value: 'LoyaltyType'}]).subscribe(res => {
      this.listLoyaltyType = [];
      for (const loyaltyType of res.data) {
        this.listLoyaltyType.push({ label: loyaltyType.description, value: loyaltyType.id });
      }
    });
  }

  loadPromotionType() {
    this.paramService.list(null , null , [{key: 'param_group', value: 'PromotionType'}]).subscribe(res => {
      this.listPromotionType = [];
      for (const promotionType of res.data) {
        this.listPromotionType.push({ label: promotionType.description, value: promotionType.id });
      }
    });
  }

  loadCustomerType() {
    this.paramService.list(null , null , [{key: 'param_group', value: 'CustomerType'}]).subscribe(res => {
      this.listCustomerType = [];
      for (const customerType of res.data) {
        this.listCustomerType.push({ label: customerType.description, value: customerType.id });
      }
    });
  }

  loadCouponingType() {
    this.paramService.list(null , null , [{key: 'param_group', value: 'CouponingType'}]).subscribe(res => {
      this.listCouponingType = [];
      for (const couponingType of res.data) {
        this.listCouponingType.push({ label: couponingType.description, value: couponingType.id });
      }
    });
  }

  createForm(res: StoreModel) {
    this.formLink = this.fb.group({
      analitics_id: [res.analitics_id || null],
      backoffice_id: [res.backoffice_id || null],
      couponing_id: [res.couponing_id || null],
      customer_id: [res.customer_id || null],
      front_end_id: [res.front_end_id || null],
      flg_graphical_printer: [res.flg_graphical_printer || false],
      flg_campaign_candidate: [res.flg_campaign_candidate || false],
      ip_address: [res.ip_address || null, KoncentroValidators.ipAddress],
      loyalty_id: [res.loyalty_id || null],
      promotion_id: [res.promotion_id || null],
      ext_flyer_url: [res.ext_flyer_url || null]
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/views/administration/store/store-common-link/store-common-link.component.ts